import React, { Fragment,useEffect,useState } from "react";
import Classes from "../css/Modal.module.css";
import axiosInstance from '../../../../utility/axios-instance';
import { TextField, Autocomplete } from '@mui/material';

const UpdateShippingPopUp = (props) => {
    const [states,setStates] = useState([]);

    const {
        updateShippingModal,
        customerIDAddress,
        hideUpdateShippingPop,
        setCustomerIDAddress,
        addressType,
        addressArray,
        setAddressArray,
        type
    } = props;

    const handleFormSubmit = (event) => {
        event.preventDefault();
        hideUpdateShippingPop();

        let lastName;
        if (event.target.last.value) {
            lastName = event.target.last.value.trim();
        } else {
            lastName = "";
        }

        let data = {
            firstName: event.target.first.value.trim(),
            lastName: lastName,
            addressLine1: event.target.address1.value,
            addressLine2: event.target.address2.value,
            city: event.target.city.value,
            pincode: event.target.pincode.value,
            state: event.target.state.value,
            addressType: addressType,
            phoneNumber: event.target.phone.value? event.target.phone.value: undefined,
        }
        
        if (type === 'Vendor') {

            axiosInstance
                .put(`/vendor/vendorAddress/${customerIDAddress[0].vendorAddressesId}`, data)
                .then((res) => {
                    let newAddresses = addressArray.filter((address) => address.vendorAddressesId !== customerIDAddress[0].vendorAddressesId);
                    setCustomerIDAddress([res.data.data]);
                    setAddressArray([...newAddresses, res.data.data]);
                });
        } else {
            axiosInstance
                .put(`/location/locationAddress/${customerIDAddress[0].locationAddressesId}`, data)
                .then((res) => {
                    let newAddresses = addressArray.filter((address) => address.locationAddressesId !== customerIDAddress[0].locationAddressesId);
                    setCustomerIDAddress([res.data.data]);
                    setAddressArray([...newAddresses, res.data.data]);
                });
        }
    }


    const handleMinLengthPinCodes = (event) => {
        const pincode = /^\d{6}$/;
        if (event.target.value.match(pincode)) {
            document.getElementById('pinErrMsg2').style.display = 'none';
        } else {
            document.getElementById('pinErrMsg2').style.display = 'block';
        }
    }
    const handleMinLengthphoneNumber = (event) => {
        const phoneNo = /^\d{10}$/;
        if (event.target.value.length === 0) {
            return
        }
        if(event.target.value.match(phoneNo)){
            document.getElementById('phoneErrMsg2').style.display = 'none';
            document.getElementById('btn').disabled = false;
        }else{
            document.getElementById('btn').disabled = true;
            document.getElementById('phoneErrMsg2').style.display = 'block';
        }
    }
    
    useEffect(() => {
        axiosInstance
            .get('/pincode/getAllStates')
            .then((response) => {
                setStates(response.data.data);
            })
    },[])

    return (
        <Fragment>
            {updateShippingModal && (
                <div
                    className={Classes.modal}
                    style={{ bottom: '10%', top: '3%' }}
                >
                    <div className={Classes.BoxContent}>
                        <p>Edit Shipping Address</p>
                    </div>

                    <form method="post" onSubmit={handleFormSubmit} id='form'>
                        <div className={Classes.AddressPopUp}>
                            <div style={{ marginTop: '10px' }}>
                                <TextField 
                                    id='country'
                                    name='country'
                                    label='Country / Origin'
                                    value='India'
                                    autoComplete='off'
                                    sx={{ width: '100%',"& label": {top:"0%",fontSize:14},"& .MuiOutlinedInput-input":{padding:'6px 10px'}}}
                                    disabled={true}
                                />
                            </div>

                            <div style={{ display:'flex',marginTop:15,justifyContent:'space-between' }}>
                                <div style={{ width:'48%' }}>
                                    <TextField 
                                        required={true}
                                        id='first'
                                        name='first'
                                        label='First Name'
                                        autoComplete='off'
                                        key={customerIDAddress[0]?.firstName}
                                        defaultValue={customerIDAddress[0]?.firstName}
                                        placeholder='Enter Your First Name'
                                        sx={{ width: '100%'}}
                                    />
                                </div>

                                <div style={{ width:'48%' }}>
                                    <TextField 
                                        id='last'
                                        name='last'
                                        label='Last Name'
                                        autoComplete='off'
                                        key={customerIDAddress[0]?.lastName}
                                        defaultValue={customerIDAddress[0]?.lastName}
                                        placeholder='Enter Your Last Name'
                                        sx={{ width: '100%'}}
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop:15 }}>
                                <TextField 
                                    required={true}
                                    id='address1'
                                    name='address1'
                                    label='Address 1'
                                    autoComplete='off'
                                    key={customerIDAddress[0]?.addressLine1}
                                    defaultValue={customerIDAddress[0]?.addressLine1}
                                    placeholder='Enter Your Address'
                                    sx={{ width: '100%'}}
                                />
                            </div>

                            <div style={{ marginTop:15 }}>
                                <TextField
                                    id='address2'
                                    name='address2'
                                    label='Address 2'
                                    autoComplete='off'
                                    placeholder='Apartment,Suite,etc'
                                    key={customerIDAddress[0]?.addressLine2}
                                    defaultValue={customerIDAddress[0]?.addressLine2}
                                    sx={{ width: '100%'}}
                                />
                            </div>

                            <div style={{ display:'flex',marginTop:15,justifyContent:'space-between' }}>
                                <div style={{ width: '48%'}}>
                                    <TextField 
                                        required={true}
                                        id='city'
                                        name='city'
                                        label='City'
                                        key={customerIDAddress[0]?.city && customerIDAddress[0]?.city}
                                        defaultValue={customerIDAddress[0]?.city && customerIDAddress[0]?.city}
                                        autoComplete='off'
                                        placeholder='Enter Your City'
                                        sx={{ width: '100%'}}
                                    />
                                </div>

                                <div style={{ width:'48%' }}>
                                    <TextField 
                                        required={true}
                                        id='pincode'
                                        name='pincode'
                                        label='Pincode'
                                        autoComplete='off'
                                        placeholder='Enter Your Pincode'
                                        maxLength={6}
                                        type="tel"
                                        sx={{ width: '100%'}}
                                        inputProps={{maxLength:6}}
                                        key={customerIDAddress[0]?.pincode}
                                        defaultValue={customerIDAddress[0]?.pincode}
                                        onBlur={(e) => handleMinLengthPinCodes(e)}
                                    />

                                    <div
                                        className={Classes.PhoneErrorMsg}
                                        id='pinErrMsg2'
                                        style={{ fontSize: '14px' }}
                                    >
                                        <p>Please enter a valid 6 digit pincode</p>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display:'flex',marginTop:10,justifyContent:'space-between' }}>
                                <div style={{ width:'48%' }}>
                                    <Autocomplete
                                        freeSolo
                                        disablePortal
                                        id="state"
                                        name='state'
                                        options={states}
                                        key={customerIDAddress[0]?.state}
                                        defaultValue={customerIDAddress[0]?.state}
                                        ListboxProps={{sx: { fontSize: 14 }}}
                                        sx={{ width: '100%' }}
                                        renderInput={(params) => <TextField {...params} label="States" required/>}
                                    />
                                </div>

                                <div style={{width: '48%'}}>
                                    <TextField 
                                        type="tel"
                                        required={true}
                                        id='phone'
                                        name='phone'
                                        label='Phone'
                                        autoComplete='off'
                                        placeholder='Enter Your Phone Number'
                                        maxLength={10}
                                        sx={{ width: '100%'}}
                                        inputProps={{maxLength:10}}
                                        key={customerIDAddress[0]?.phoneNumber}
                                        defaultValue={customerIDAddress[0]?.phoneNumber}
                                        onBlur={(e) => handleMinLengthphoneNumber(e)}
                                    />

                                    <div 
                                        className={Classes.PhoneErrorMsg} 
                                        id='phoneErrMsg2' 
                                        style={{fontSize:'15px'}}
                                    >
                                        <p>Please enter a valid 10 digit mobile number</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={Classes.DialogBtnBox} style={{bottom: "10%"}}>
                            <button 
                                type="button" 
                                className={Classes.UpdateSalesUserOfCustomer}
                                onClick={hideUpdateShippingPop}
                            >
                                CANCEL
                            </button>

                            <button 
                                id='btn' 
                                type="submit" 
                                className={Classes.UpdateSalesUserOfCustomer}
                            >
                                UPDATE
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </Fragment>
    );
}


export default UpdateShippingPopUp;